import { gql } from "@apollo/client";

export const GET_HEIGHTS_BY_PATIENT_ID = gql`
  query HeightsByPatientId($patient_id: ID!) {
    heightsByPatientId(patient_id: $patient_id) {
      _id
      patient_id
      date
      value
      createdAt
    }
  }
`;

export const GET_HEIGHT_BY_ID = gql`
  query HeightById($id: ID!) {
    heightById(_id: $id) {
      _id
      patient_id
      date
      value
      createdAt
    }
  }
`;

export const GET_HEIGHTS_BY_IDS = gql`
  query HeightsByIds($ids: [ID!]!) {
    heightsByIds(ids: $ids) {
      _id
      patient_id
      date
      value
      createdAt
    }
  }
`;
